module.exports = __webpack_public_path__ + "img/ad1.2ea79535.png";